import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Habilitar"}>
                                <Button
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "close" : "check"}
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Razón Social',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Condición Sunat',
                    dataIndex: 'nombreCondicionSunat',
                    key: 'nombreCondicionSunat',
                    sorter: true
                },
                {
                    title: 'Estado Contribuyente',
                    dataIndex: 'nombreEstadoContribuyente',
                    key: 'nombreEstadoContribuyente',
                    sorter: true
                },
                {
                    title: 'Plan Cuenta Soles',
                    dataIndex: 'planCuentaSoles',
                    key: 'planCuentaSoles',
                    sorter: true
                },
                {
                    title: 'Plan Cuenta Dólares',
                    dataIndex: 'planCuentaDolares',
                    key: 'planCuentaDolares',
                    sorter: true
                },
                {
                    title: 'Abreviatura',
                    dataIndex: 'abreviatura',
                    key: 'abreviatura',
                    sorter: true
                },

                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}